/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import notification from "../config/notifications.config.json";
import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { SUBMIT_PORTFOLIO_TEMPLATE } from "../graphql";


const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ISubmitTemplateMethods extends IPluginMethodMap {
  getSubmitTemplate(args: any): Promise<any>;
}

export interface SubmitTemplateProps {
  jsonFormat: JSON;
  jsonldFormat: JSON;
  preview: {
    credentialName: string;
    credentialLogo: string;
    credentialDescription: string;
    credentialBanner: string;
    credentialList:any[];
    userGroupList:any[];
  };
}

export class SubmitTemplateService implements IAgentPlugin {
  readonly methods: ISubmitTemplateMethods;

  constructor() {
    this.methods = {
      getSubmitTemplate: this.getSubmitTemplate.bind(this),
    };
  }

  async getSubmitTemplate(args: SubmitTemplateProps) {
    console.log(`args in submit template`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.mutate({
          mutation: SUBMIT_PORTFOLIO_TEMPLATE,
          variables: {
            input: {
              name: args?.preview?.credentialName,
              logo: args?.preview?.credentialLogo,
              bannerImage:args?.preview?.credentialBanner,
              description: args?.preview?.credentialDescription,
              credentialSchemas: this.getIds(args?.preview?.credentialList),
              userGroup:this.getIds(args?.preview?.userGroupList)
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data?.createPortfolioTemplate) {
          console.log(`table data`, res);
          return {
            ...res?.data?.createPortfolioTemplate,
            notification: notification?.createTemplate,
          };
        }
      }
    } catch (err: any) {
      return err;
    }
  }

  private getIds(data:any){
    let _tempIds:any = [];
   if(Array.isArray(data) && data?.length > 0){
    data?.forEach(element => {
      _tempIds.push(element?.appCardId)
    });
   }
    // console.log('app card id selected:', _credentials);
    return _tempIds;
  }
}
